module.exports = __webpack_public_path__ + "img/testA1.238a6138.webp";